import { getConditionalObject } from 'utils/data';

import { CHART_COLORS, CHART_HEIGHT, LTV_LIMIT } from './Chart.constants';

const PERCENTAGE = 100;

export const chartStyles = {
  width: '100%',
  height: `${CHART_HEIGHT}px`,
  margin: '40px 0 64px',
};

export const getChartSegmentStyles = ({ percentage, color, isHover }) => ({
  position: 'relative',
  width: `${percentage * PERCENTAGE}%`,
  height: '100%',
  backgroundColor: color,

  ...getConditionalObject(color === CHART_COLORS.RED, {
    flexShrink: 0,
    minWidth: `${LTV_LIMIT.WIDTH}px`,
  }),

  ...getConditionalObject(isHover, {
    cursor: 'pointer',
  }),
});

export const getChartInfoStyles = ({ color, isHoverInfo, percentage }) => ({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  padding: '0 4px',
  gap: '4px',
  borderRight: ({ palette }) => `1px solid ${palette.border.strong}`,
  right: '0',
  width: '100%',
  height: '80px',
  bottom: '0',

  ...getConditionalObject(color === CHART_COLORS.RED && percentage < LTV_LIMIT.PERCENT, {
    minWidth: `${LTV_LIMIT.WIDTH}px`,
    top: '0',
    left: '0',
    justifyContent: 'flex-end',
  }),

  ...getConditionalObject(color === CHART_COLORS.BLUE, {
    top: '0',
    justifyContent: 'flex-end',
  }),

  ...getConditionalObject(color === CHART_COLORS.GREEN, {
    top: '0',
    height: '52px',
    justifyContent: 'flex-end',
  }),

  ...getConditionalObject(isHoverInfo, {
    cursor: 'pointer',
  }),
});

export const tooltipStyles = {
  backgroundColor: ({ palette }) => palette.background.paper,
  padding: '24px',
  borderRadius: ({ shape }) => shape.radius.l,
  boxShadow: ({ palette }) => palette.shadow.s,
  maxWidth: 'none',
};

export const getIndicatorStyles = ({ color }) => ({
  width: '20px',
  height: '20px',
  backgroundColor: color,
  borderRadius: '50%',
});

export const customDividerStyles = {
  backgroundColor: ({ palette }) => palette.background.hoverDefault,
  width: '1px',
  height: '100%',
};
